import React, { useEffect, useState } from "react";
import FaqDrawer from "../components/FaqDrawer";
import { getActiveSupportFaqs } from "../api/faq.api";
import PageContent from "../../../app/layouts/PageContent";

const FaqHelpPage = () => {
  const [faqs, setFaqs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const [selectedFaq, setSelectedFaq] = useState<any>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await getActiveSupportFaqs();

        if (response.success) {
          setFaqs(response.data.rows);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  const openFaq = (faq: any) => {
    setSelectedFaq(faq);
    setDrawerOpen(true);
  };

  if (loading) {
    return (
      <PageContent>
        <div className="flex justify-center items-center mt-16">
          <div className="w-10 h-10 border-4 border-[#3b519c] border-t-transparent rounded-full animate-spin" />
        </div>
      </PageContent>
    );
  }

  return (
    <PageContent>

        {/* WHITE SUPPORT CARD */}
        <div className="bg-white rounded-xl shadow-sm p-10 max-w-6xl mx-auto">

          {/* HEADER */}
          <div className="mb-10">
            <h2 className="text-3xl font-bold text-[#26295e]">
              Tech Support
            </h2>

            <div className="w-10 h-1 bg-[#3b519c] mt-2 mb-4"></div>

            <p className="text-gray-500 max-w-2xl">
              Having technical issues? Look through our frequently asked
              questions for quick advice. If you need further help feel free
              to contact support.
            </p>
          </div>

          {/* POPULAR QUESTIONS */}
          <h3 className="text-2xl font-bold text-[#26295e] mb-6">
            Popular Questions
          </h3>

          {/* QUESTIONS GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

            {faqs.map((faq) => (
              <button
                key={faq.id}
                onClick={() => openFaq(faq)}
                className="
                  bg-[#e3e9ff]
                  text-[#2b3a8a]
                  px-5
                  py-3
                  rounded-xl
                  text-sm
                  font-medium
                  text-left
                  hover:bg-[#d2dbff]
                  transition
                  duration-200
                  shadow-sm
                "
              >
                {faq.label}
              </button>
            ))}

          </div>

        </div>

        {/* DRAWER */}
        <FaqDrawer
          open={drawerOpen}
          toggle={() => setDrawerOpen(false)}
          faq={selectedFaq}
        />

    </PageContent>
  );
};

export default FaqHelpPage;